import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class RegionDeliveryRangeSettingEntity {
  id?: number
  region?: RegionMiniEntity
  currentRange?: number
  defaultRange?: number
  reducedRange?: number
  ratioThreshold?: number
  autoDispatchPeakRatioThreshold?: number
  manualOverrideUntil?: string | null
  isManualOverride?: boolean
  targetRange?: number | null
  regionRatio?: number | null
  usedRangeName?: string | null
  updatedAt?: string
}
